import { useContext } from "react";
import {
  SellarSessionContext,
  SellarSessionState,
} from "../contexts/SellarSessionContext";

export type { SellarSessionState };

export const useSellarSession = () => {
  const session = useContext(SellarSessionContext);
  if (!session) {
    throw new Error("useSellarSession must be within SellarSessionProvider");
  }
  return session;
};
